import React from "react";
import styled from "styled-components";
import { SuccessMessage, WarningMessage, ErrorMessage, InfoMessage } from "./PathwayAlertMessages";

const renderMessages = (messages, style, onClick, MessageComponent) => {
    if (!messages || messages.length === 0) return null;
    return (
        <MessageComponent style={style} onClick={onClick}>
            {Array.isArray(messages) ? (
                <Messages>
                    {messages.map((item, key) => (
                        <div key={key} style={{ whiteSpace: "pre-line" }} dangerouslySetInnerHTML={{ __html: item }} />
                    ))}
                </Messages>
            ) : (
                <div style={{ whiteSpace: "pre-line" }} dangerouslySetInnerHTML={{ __html: messages }} />
            )}
        </MessageComponent>
    );
};

const AlertComponent = ({ successMessages, warningMessages, errorMessages, infoMessages, style, onClick }) => {
    return (
        <>
            {renderMessages(infoMessages, style, onClick, InfoMessage)}
            {renderMessages(successMessages, style, onClick, SuccessMessage)}
            {renderMessages(warningMessages, style, onClick, WarningMessage)}
            {renderMessages(errorMessages, style, onClick, ErrorMessage)}
        </>
    );
};

export default AlertComponent;

const Messages = styled.div`
    display: grid;
    row-gap: var(--gap-s);
`;
